import { Check } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { BOOKING_URL, IMAGES, WHATSAPP_URL } from "../data/content";

const POINTS = [
  "Delivered to your Residence, Apartment, or Hotel Suite across DLF Cyber City, Golf Course Road, Sohna Road & MG Road.",
  "Therapists arrive with professional portable tables, warm oils, towels, and ambient music.",
];

export const Doorstep = () => (
  <section
    id="doorstep"
    data-testid="doorstep-section"
    className="px-4 sm:px-8 lg:px-12 py-16 md:py-24 max-w-7xl mx-auto"
  >
    <FadeIn>
      <div className="relative rounded-3xl overflow-hidden min-h-[420px] flex items-center p-8 sm:p-14 border border-amber-400/20">
        <img
          src={IMAGES.doorstep}
          alt="Doorstep spa service in Gurgaon"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70 z-10" />
        <div className="relative z-20 max-w-2xl flex flex-col gap-6">
          <p className="text-amber-400 text-xs font-bold uppercase tracking-[0.3em]">
            Gurgaon Special
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-white">
            G69 Spa at Your Doorstep in Gurgaon
          </h2>
          <ul className="flex flex-col gap-4">
            {POINTS.map((p, i) => (
              <li
                key={i}
                data-testid={`doorstep-feature-${i}`}
                className="flex items-start gap-3 text-white/80 text-sm sm:text-base font-light"
              >
                <Check className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
                {p}
              </li>
            ))}
          </ul>
          <div className="flex flex-col sm:flex-row gap-4 mt-2">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="doorstep-book-btn"
              className="text-center bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 text-black px-8 py-4 rounded-full text-sm font-bold uppercase tracking-[0.2em] hover:shadow-[0_0_25px_rgba(245,158,11,0.5)] transition-shadow duration-300"
            >
              Book Now
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="doorstep-whatsapp-btn"
              className="text-center border border-emerald-400/50 text-emerald-300 px-8 py-4 rounded-full text-sm font-bold uppercase tracking-[0.2em] hover:bg-emerald-400/10 transition-colors duration-300"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </FadeIn>
  </section>
);
